import React from 'react';
import { StardustSparksOnlyIcon } from 'design-system/components';

export const defaultIndicator = <StardustSparksOnlyIcon className="ng-spinner--brand" />;

export function initSpinDefaultIndicator() {
  /* no-op: vendor removed */
}

export function withSpinConfig(children) {
  return <>{children}</>;
}
